<template>
  <fo-layout class="white-bg">
    <div class="aboutb" v-if="loading">
      <div class="posi-imga centerimage"
        :style="'background-image: url(' + item.big_img + ')'"></div>
      <div class="posi-imgb centerimage"
        :style="'background-image: url(' + item.small_img + ')'"></div>
      <div class="aboutb-bar">
        <p class="primary title-alt">
          <span class="dis-bl ht-20 gray-bg wi-180 mb-10"></span>
        </p>
        <p class="primary title">
          <span class="dis-bl ht-50 gray-bg"></span>
        </p>
      </div>
      <table width="100%">
        <tr>
          <td width="46%" valign="top">
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
          </td>
          <td></td>
          <td width="46%" valign="top">
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="aboutb" v-else>
      <div class="posi-imga centerimage"
        :style="'background-image: url(' + item.big_img + ')'"></div>
      <div class="posi-imgb centerimage"
        :style="'background-image: url(' + item.small_img + ')'"></div>
      <div class="aboutb-bar">
        <p class="primary title-alt">{{item.subtitle}}</p>
        <p class="primary title">{{item.title}}</p>
      </div>
      <table width="100%">
        <tr>
          <td width="46%" valign="top">{{item.infoa}}</td>
          <td></td>
          <td width="46%" valign="top">{{item.infob}}</td>
        </tr>
      </table>
      <div class="min-width">
        <p>{{item.infoa}}</p>
        <p>{{item.infob}}</p>
      </div>
    </div>
  </fo-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      item: {
        title: '',
        subtitle: '',
        infoa: '',
        infob: '',
        big_img: '',
        small_img: '',
        home_img: ''
      }
    }
  },
  watch: {
    'commonData.web_comp_intro' (obj) {
      this.item = JSON.parse(obj.value)
    }
  },
  mounted () {
    if (this.commonData.web_comp_intro.value) {
      this.item = JSON.parse(this.commonData.web_comp_intro.value)
    }
  }
}
</script>

<style lang="less">
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
.aboutb {
  width: 100%;
  height: 660px;
  position: relative;
  padding-left: calc(36% + 240px);
  padding-top: 50px;
  .posi-imga,
  .posi-imgb {
    position: absolute;
  }
  table {
    display: none;
  }
  .min-width {
    position: absolute;
    left: 0;
    top: 440px;
    padding-right: 16px;
    height: 240px;
    overflow: auto;
  }
  .posi-imga {
    width: 290px;
    height: 290px;
    z-index: 1;
    right: calc(64% - 160px);
    top: 0;
  }
  .posi-imgb {
    width: 120px;
    height: 120px;
    top: 240px;
    /*left: 38%;*/
    right: 20px;
  }
  .aboutb-bar {
    font-family: Georgia, 宋体;
    margin-bottom: 40px;
    position: absolute;
    left: 0;
    top: 360px;
    .title-alt {
      font-size: 14px;
    }
    .title {
      font-size: 28px;
      font-weight: bold;
      margin: 0;
      position: relative;
      z-index: 2;
    }

  }
  .newspaper-to2 {
    -moz-column-count:2; /* Firefox */
    -webkit-column-count:2; /* Safari and Chrome */
    column-count:2;
    -moz-column-gap:40px; /* Firefox */
    -webkit-column-gap:40px; /* Safari and Chrome */
    column-gap:40px;
  }
}
}
/* 大于 750 */
@media screen and (min-width: 751px) {
.aboutb {
  width: 100%;
  min-height: 700px;
  position: relative;
  padding-left: calc(36% + 240px);
  padding-top: 50px;
  .posi-imga,
  .posi-imgb {
    position: absolute;
  }
  .min-width {
    display: none;
  }
  .posi-imga {
    width: 800px;
    height: 550px;
    z-index: 1;
    right: calc(64% - 160px);
    top: 0;
  }
  .posi-imgb {
    width: 200px;
    height: 200px;
    bottom: 0;
    left: 38%;
  }
  .aboutb-bar {
    width: 750px;
    font-family: Georgia, 宋体;
    margin-bottom: 40px;
    .title-alt {
      font-size: 16px;
      margin: 0;
    }
    .title {
      font-size: 4em;
      font-weight: bold;
      margin: 0;
      position: relative;
      z-index: 2;
      left: -30%;
    }
  }
  .newspaper-to2 {
    -moz-column-count:2; /* Firefox */
    -webkit-column-count:2; /* Safari and Chrome */
    column-count:2;
    -moz-column-gap:40px; /* Firefox */
    -webkit-column-gap:40px; /* Safari and Chrome */
    column-gap:40px;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/aboutb.vue